export default function refreshTween(tween) {
    const sectionsToObserve = document.querySelectorAll('.stage-animation, section, .header-reveal');
    if (sectionsToObserve) {
        const resizeObserver = new ResizeObserver(() => {
            tween.forEach((item) => {
                if(item.scrollTrigger) {
                    setTimeout(() => {
                        item.scrollTrigger?.refresh();
                    }, 50);
                }
            });
        });
        sectionsToObserve.forEach((section) => {
            resizeObserver.observe(section, {
                subtree: true,
                childList: true,
                attributes: true,
                attributeFilter: ['style', 'height'],
            });
        });
    }
};
